import React, { useState } from 'react';
import { Form, Dropdown, Popup } from 'semantic-ui-react';
export const SelectField = props => {
  const [selection, setSelection] = useState([]);

  const handleChange = (e, { name, value }) => {
    if (props.multiple && value.length < 2) {
      props.formik.setFieldValue(name, value);
      setSelection(value);
    } else {
      props.formik.setFieldValue(name, value);
      setSelection(value);
    }
  };

  return (
    <Form.Field error={props.error}>
      {props.tip ? (
        <Popup content={props.tip || ''} trigger={<strong>{props.label}</strong>} />
      ) : (
        <strong>{props.label}</strong>
      )}

      <Dropdown
        fluid
        search
        loading={props.loading ? props.loading : false}
        selection
        clearable={!props.clearable ? props.clearable : true}
        selected={selection}
        multiple={props.multiple}
        key={props.id ? props.id + '-' + props.name : props.name}
        options={props.options || []}
        id={props.name}
        label={props.label}
        name={props.name}
        value={props.value}
        onChange={(e, d) => {
          handleChange(e, d);
          if (props.cb) {
            console.log('calling cb');
            props.cb();
          }
        }}
        size={props.size ? props.size : 'small'}
        error={Boolean(props.error)}
      />
    </Form.Field>
  );
};

export const TextField = props => {
  return (
    <Form.Field required={props.required} error={Boolean(props.error)}>
      {props.tip ? (
        <Popup
          content={props.tip || ''}
          trigger={
            <strong>
              {props.label}
              {props.required && <span aria-hidden="true"> *</span>}
            </strong>
          }
        />
      ) : (
        <strong>
          {props.label}
          {props.required && <span aria-hidden="true"> *</span>}
        </strong>
      )}

      <Form.Input
        fluid
        key={props.id ? props.id + '-' + props.name : props.name}
        name={props.name}
        data-cy={props.name}
        data-testid={props.name}
        spellCheck="true"
        style={{ paddingTop: 5 }}
        disabled={props.disabled}
        type={props.type}
        required={props.required}
        aria-required={props.required}
        aria-invalid={Boolean(props.error)}
        aria-describedby={props.error ? `${props.name}-error` : undefined}
        value={props.value}
        size={props.size ? props.size : 'small'}
        onChange={props.onChange}
        error={Boolean(props.error)}
      />
      {props.error && (
        <span id={`${props.name}-error`} role="alert" style={{ color: '#9f3a38' }}>
          {props.errorMessage}
        </span>
      )}
    </Form.Field>
  );
};
